import React from 'react'

function CampaignInformationStep({ formData, setFormData, entityLabel = 'Campaign' }) {
    return (
        <div className="animate-fade-in">
            <h3 className="fw-normal text-dark mb-2">{entityLabel} Information</h3>
            <p className="text-muted mb-8">This information is for internal use and to identify the {entityLabel.toLowerCase()}.</p>
            
            <div className="mb-6">
                <label className="form-label fw-normal" htmlFor="blast-name">
                    {entityLabel} Name <span className="text-danger">*</span>
                </label>
                <input 
                    id="blast-name"
                    type="text" 
                    className="form-control form-control-lg" 
                    placeholder={`Enter ${entityLabel.toLowerCase()} name`}
                    value={formData.campaignName}
                    onChange={(e) => setFormData({...formData, campaignName: e.target.value})}
                    required
                    maxLength={255}
                />
            </div>
            
            <div className="mb-6">
                <label className="form-label fw-normal">Short Description</label>
                <textarea 
                    className="form-control form-control-lg" 
                    rows="3"
                    placeholder="Enter a brief description"
                    value={formData.description}
                    onChange={(e) => setFormData({...formData, description: e.target.value})}
                ></textarea>
            </div>
        </div>
    )
}

export default CampaignInformationStep
